export default {
  INITIATED: 'initiated',
  PAID: 'paid',
  CANCELLED: 'cancelled',
  STOPPED: 'stopped',
};



// WEBPACK FOOTER //
// ./src/variables/ski/pass/status-type-enums.js